
import {
  Box, Button, Card, FormControl, FormLabel, Input,
  Radio, RadioGroup, Typography,
} from '@mui/joy';
import { useEffect, useState } from 'react';

const FormRenderer = ({ form, isPreview, onSubmit, isPosting, result }) => {
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted answers:', answers);
    onSubmit(answers);
  };

  const handleAnswerChange = (questionId, value) => {
    const question = form.questions.find(q => q.id === questionId);
    if (question.type === 'yesno') {
      // 
    } else if (question.type === 'numeric') {
      value = value.trim() !== "" ? Number(value) : "";
    }

    // Update the answer state
    setAnswers({
      ...answers,
      [questionId]: value
    });
  };

  // const checkAnswers = () => {
  //   setSubmitted(true);
  // };

  const isAnswerCorrect = (question) => {
    if (!submitted) return null;

    const userAnswer = answers[question.id];
    if (question.type === 'yesno') {
      return userAnswer === question.correctAnswer;
    } else {
      const numValue = Number(userAnswer);
      return numValue >= question.minValue && numValue <= question.maxValue;
    }
  };

  useEffect(() => {
    if (result) {
      setAnswers(result);
      setSubmitted(true);
    }
  }, [result]);

  if (!form || !form.questions || form.questions.length === 0) {
    return <Typography level='h5' sx={{ maxWidth: 200, mx: 'auto', p: 2 }}>No form data available</Typography>;
  }

  return (
    <Box sx={{ p: 0 }} component={'form'} onSubmit={handleSubmit}>
      {!isPreview && <Typography level="h2" mb={3}>{form.title || 'Questionnaire'}</Typography>}

      {form.questions.map((question) => {
        const correct = isAnswerCorrect(question);
        const color = submitted ? (correct ? 'success' : 'danger') : 'neutral';
        const value = answers[question.id] ?? '';

        return (
          <Card key={question.id} sx={{ mb: 2, p: 2 }}>
            <FormControl required>
              <FormLabel level="title-md">
                {question.text}
              </FormLabel>

              {question.type === 'yesno' ? (
                <RadioGroup
                  value={value}
                  onChange={(e) => handleAnswerChange(question.id, e.target.value)}
                >
                  <Radio value="yes" label="Yes" disabled={submitted} required />
                  <Radio value="no" label="No" disabled={submitted} required />
                </RadioGroup>
              ) : (
                // <FormControl>
                <Input
                  type="number"
                  value={value + ""}
                  onChange={(e) => handleAnswerChange(question.id, e.target.value)}
                  placeholder="Enter a number"
                  disabled={submitted}
                />
                // </FormControl>
              )}

              {submitted && (
                <Typography color={color} mt={1}>
                  {correct ? '✓ Correct' : '✗ Incorrect'}
                  {!correct && question.type === 'numeric' && (
                    ` (Expected between ${question.minValue} and ${question.maxValue})`
                  )}
                </Typography>
              )}
            </FormControl>
          </Card>

        );
      })}
      {/* {!submitted ? (
        <Button onClick={checkAnswers} sx={{ mt: 2 }}>Submit Answers</Button>
      ) : (
        <Button onClick={() => setSubmitted(false)} sx={{ mt: 2 }}>Try Again</Button>
      )} */}
      {!isPreview && <Button type="submit" sx={{ mt: 0 }} loading={isPosting}>Submit Answers</Button>}
    </Box>
  );
};

export default FormRenderer;